function isMotionValue(value) {
  return Boolean(value && value.getVelocity);
}
export {
  isMotionValue
};
